import React, { useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import CommonSideNavbar from "../common/CommonSideNavbar";
import {
  clientDashboard,
  clientProfile,
  activeLinkDashboard,
} from "../common/allLinks";
import ClientDashboardNewRequirementsFirstTime from "./ClientDashboardNewRequirementsFirstTime";
import ClientDashboardNewRequirements from "./ClientDashboardNewRequirements";
import ClientDashboardFulfilledRequirements from "./ClientDashboardFulfilledRequirements";

export default function ClientDashboard() {
  const handleOnSelect = (val) => {
    // activeClientDashboardTabIndex
    localStorage.setItem("activeClientDashboardTabIndex", val);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="mt-dashboard-agency-bg">
      <CommonSideNavbar
        dashboardLink={clientDashboard}
        profileLink={clientProfile}
        activeLink={activeLinkDashboard}
      />
      <div className="sidenavbar-active-menu-page">
        <div className="mt-title-block">
          <h1 className="mt-dashboard-title">Dashboard</h1>
        </div>
        <div className="mt-platform-tabs">
          <Tabs
            defaultIndex={parseInt(
              localStorage.getItem("activeClientDashboardTabIndex")
            )}
            onSelect={handleOnSelect}
          >
            <TabList>
              <Tab>Current Requirements</Tab>
              <Tab>Fulfilled Requirements</Tab>
            </TabList>
            <TabPanel>
              {true ? (
                <ClientDashboardNewRequirementsFirstTime />
              ) : (
                <ClientDashboardNewRequirements />
              )}
            </TabPanel>
            <TabPanel>
              <ClientDashboardFulfilledRequirements />
            </TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
}
